import React from 'react';
import DetailBanner from "./detail-banner";

function StrategyPerformance({ strategyId }) {
	return (
		<div className="strategy-performance">
			<p>Sample Campaign Name Here</p>
			<DetailBanner strategyId={strategyId} />
		</div>
	);
}

export default StrategyPerformance;
